<script setup lang="ts">
defineProps<{
  post: Post.Info
  rank?: number
}>()
</script>

<template>
  <figure :key="post.id" class="m-post-card">
    <m-link
      block
      hide
      :resource-id="post.id"
      :resource-type="post.type"
      :title="post.title"
      class="m-post-card__cover"
    >
      <m-img
        class="m-post-card__img"
        width="320"
        :src="post.cover"
        :alt="post.title"
        :title="post.title"
      />
      <div v-if="post.duration" class="m-post-card__duration">
        {{ pipe.time(post.duration) }}
      </div>
      <div
        v-if="post.type === 0 && !post.duration"
        class="m-post-card__duration"
      >
        <m-text size="xs">文章</m-text>
      </div>
      <div
        v-if="post.type === 1 && !post.duration"
        class="m-post-card__duration"
      >
        <m-text size="xs">视频</m-text>
      </div>
      <div
        v-if="rank"
        class="m-post-card__rank"
        :class="{
          first: rank === 1,
          second: rank === 2,
          third: rank === 3
        }"
      >
        {{ rank }}
      </div>
    </m-link>
    <figcaption class="m-post-card__info">
      <m-link
        :resource-id="post.id"
        :resource-type="post.type"
        :title="post.title"
        class="m-post-card__title"
      >
        <RTitle
          size="h3"
          ellipsis
          :rows="2"
          :title="post.title"
          class="m-post-card__title-text"
        >
          {{ post.title }}
        </RTitle>
      </m-link>
      <div class="m-post-card__info-text">
        <m-icon :size="12" class="icon" icon="i-solar:user-linear" />
        <m-text size="xs" ellipsis class="text">{{ post.user.name }}</m-text>
      </div>
      <div class="m-post-card__info-text">
        <m-icon :size="12" class="icon" icon="i-mingcute:thumb-up-2-line" />
        <div class="text">{{ pipe.num(post.like_count || 0) }}</div>
        <m-icon
          :size="12"
          class="icon"
          :icon="post.type === 1 ? 'i-radix-icons:video' : 'i-solar:eye-linear'"
        />
        <div class="text">{{ pipe.num(post.view_count || 0) }}</div>
      </div>
    </figcaption>
  </figure>
</template>

<style lang="scss" scoped>
.m-post-card {
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  &__cover {
    position: relative;
    margin-right: 8px;
    width: 140px;
    height: 78.75px;
  }
  &__img {
    border-radius: 8px;
    object-fit: cover;
  }
  &__duration {
    position: absolute;
    right: 4px;
    bottom: 4px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    line-height: 12px;
    border-radius: 4px;
    text-align: center;
    padding: 4px;
    box-sizing: border-box;
    z-index: 1;
  }
  &__rank {
    position: absolute;
    left: 0;
    top: 0;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    line-height: 12px;
    border-radius: 4px 0 0 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    &.first {
      background-color: var(--color-red-400);
    }
    &.second {
      background-color: var(--color-yellow-400);
    }
    &.third {
      background-color: var(--color-blue-400);
    }
  }
  &__info {
    flex: 1;
    width: 0;
    height: 78.75px;
    margin-left: 8px;
    padding: 1px 0;
    display: flex;
    flex-direction: column;
  }
  &__title {
    margin-bottom: auto;
    &-text {
      font-size: 12px !important;
      line-height: 1.2;
      margin-bottom: 0;
    }
  }
  &__info-text {
    color: var(--text-secondary);
    font-size: 12px;
    display: flex;
    align-items: center;
    padding-right: 12px;
    padding-top: 2px;
    .text {
      margin-left: 4px;
      margin-right: 12px;
    }
  }
}
</style>
